import { Link } from 'react-router-dom'
import { formatNewsDate } from '../../../Model/News/newsArticle.js'
import { newsArticles, newsImageUrl } from '../../../Model/News/newsArticles.js'

export const NewsListPage = () => (
  <div className="mx-auto w-full max-w-5xl p-4">
    <h1 className="mb-6 text-3xl font-bold text-slate-900">News</h1>
    {newsArticles.length === 0 && <p className="text-slate-600">No news yet.</p>}
    <ul className="space-y-4">
      {newsArticles.map((article) => {
        const heroUrl = newsImageUrl(article, article.hero)
        return (
          <li key={article.slug}>
            <Link
              to={`/news/${article.slug}`}
              className="group flex gap-4 rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-primary/40 hover:shadow"
            >
              {heroUrl && <img src={heroUrl} alt="" className="hidden h-24 w-36 shrink-0 rounded-lg object-cover sm:block" />}
              <div className="min-w-0">
                <p className="text-xs font-semibold uppercase tracking-widest text-primary-600">{formatNewsDate(article.date)}</p>
                <h2 className="mt-1 text-lg font-semibold text-slate-900 group-hover:text-primary-600">{article.title}</h2>
                {article.teaser && <p className="mt-1 text-sm text-slate-600">{article.teaser}</p>}
              </div>
            </Link>
          </li>
        )
      })}
    </ul>
  </div>
)
